var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragdrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 24,
    viewBox: "0 0 10 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5994_3005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z",
    fill: "#AFBCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10C2.32843 10 3 9.32843 3 8.5C3 7.67157 2.32843 7 1.5 7C0.671573 7 0 7.67157 0 8.5C0 9.32843 0.671573 10 1.5 10Z",
    fill: "#AFBCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3C9.32843 3 10 2.32843 10 1.5C10 0.671573 9.32843 0 8.5 0C7.67157 0 7 0.671573 7 1.5C7 2.32843 7.67157 3 8.5 3Z",
    fill: "#AFBCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z",
    fill: "#AFBCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 17C2.32843 17 3 16.3284 3 15.5C3 14.6716 2.32843 14 1.5 14C0.671573 14 0 14.6716 0 15.5C0 16.3284 0.671573 17 1.5 17Z",
    fill: "#AFBCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C9.32843 17 10 16.3284 10 15.5C10 14.6716 9.32843 14 8.5 14C7.67157 14 7 14.6716 7 15.5C7 16.3284 7.67157 17 8.5 17Z",
    fill: "#AFBCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 24C2.32843 24 3 23.3284 3 22.5C3 21.6716 2.32843 21 1.5 21C0.671573 21 0 21.6716 0 22.5C0 23.3284 0.671573 24 1.5 24Z",
    fill: "#AFBCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 24C9.32843 24 10 23.3284 10 22.5C10 21.6716 9.32843 21 8.5 21C7.67157 21 7 21.6716 7 22.5C7 23.3284 7.67157 24 8.5 24Z",
    fill: "#AFBCD5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5994_3005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragdrop);
export default __webpack_public_path__ + "static/media/dragdrop.fcd0e2e1.svg";
export { ForwardRef as ReactComponent };